import React, { useState, useEffect } from "react";

import ClubbieModal from "../../../Modal/ClubbieModal";
import LoadingSpinner from "../../../LoadingSpinner/LoadingSpinner";

const BracketGroupModal = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
  bracketName = "",
  initialData = { name: "", numGroups: 1, teamsPerGroup: 4 },
}) => {
  const [formData, setFormData] = useState({
    name: "",
    numGroups: 1,
    teamsPerGroup: 4,
  });

  useEffect(() => {
    if (isOpen) {
      // Use initialData or defaults when opening the modal
      setFormData({
        name: initialData.name || "",
        numGroups: initialData.numGroups || 1,
        teamsPerGroup: initialData.teamsPerGroup || 4,
      });
    }
    // Only depend on isOpen to prevent infinite update loops
  }, [isOpen]);

  const handleSubmit = () => {
    // Validate form
    if (!formData.name.trim()) {
      return;
    }
    
    // Submit data to parent component
    onSubmit({
      ...formData,
      numGroups: parseInt(formData.numGroups),
      teamsPerGroup: parseInt(formData.teamsPerGroup),
    });
  };

  const handleClose = () => {
    setFormData({
      name: "",
      numGroups: 1,
      teamsPerGroup: 4,
    });
    onClose();
  };

  return (
    <ClubbieModal
      isOpen={isOpen}
      width="500px"
      toggle={handleClose}
      title={`Add group in ${bracketName || "bracket"}`}
    >
      <div className="space-y-5 p-1">
        {/* Group Name Input */}
        <div className="space-y-2">
          <label className="block text-[14px] font-normal text-app-text mb-1.5 ">
            Group name
          </label>
          <input
            type="text"
            className="w-full h-12 px-4 bg-app-surface border border-app-surface rounded-full text-[14px] text-[#FEFCEB] placeholder-app-text-secondary font-proxima focus:outline-none focus:border-[#00E7FF] transition-colors"
            value={formData.name}
            placeholder="Group B"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
          />
        </div>

        {/* Number of Groups Input */}
        <div className="space-y-2">
          <label className="block text-[14px] font-normal text-app-text mb-1.5 ">
            How many groups do you want to create?
          </label>
          <input
            type="number"
            className="w-full h-12 px-4 bg-app-surface border border-app-surface rounded-full text-[14px] text-[#FEFCEB] placeholder-app-text-secondary font-proxima focus:outline-none focus:border-[#00E7FF] transition-colors"
            value={formData.numGroups}
            min="1"
            placeholder="Enter a number of groups"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                numGroups: e.target.value ? parseInt(e.target.value) : "",
              }))
            }
          />
        </div>

        {/* Teams Per Group Input */}
        <div className="space-y-2">
          <label className="block text-[14px] font-normal text-app-text mb-1.5 ">
            How many teams are there in each group?
          </label>
          <input
            type="number"
            className="w-full h-12 px-4 bg-app-surface border border-app-surface rounded-full text-[14px] text-[#FEFCEB] placeholder-app-text-secondary font-proxima focus:outline-none focus:border-[#00E7FF] transition-colors"
            value={formData.teamsPerGroup}
            min="2"
            placeholder="Enter number of teams"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                teamsPerGroup: e.target.value ? parseInt(e.target.value) : "",
              }))
            }
          />
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            type="button"
            className="px-6 py-2.5 rounded-full bg-[#0A1929] text-[#FEFCEB] text-sm font-medium hover:bg-[#0D1B29] transition-colors"
            onClick={handleClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className="px-6 py-2.5 rounded-full bg-[#00BCD2] text-[#081725] text-sm font-medium hover:bg-[#00E7FF] transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
            onClick={handleSubmit}
            disabled={isLoading || !formData.name.trim() || !formData.numGroups || !formData.teamsPerGroup}
          >
            {isLoading ? (
              <>
                <LoadingSpinner size="small" />
                <span>Creating...</span>
              </>
            ) : (
              "Create"
            )}
          </button>
        </div>
      </div>
    </ClubbieModal>
  );
};

export default BracketGroupModal;
